@if (collapsable) {
	<div class="billing-header" [ngClass]="{'with-margin': !billingVisible}">
		<h6 class="billing-label">Billing preferences</h6>
		@if (collapsable) {
			<a class="toggle-view-section" (click)="billingVisible = !billingVisible">
				{{ billingVisible ? 'Hide' : 'Show' }}
				<nb-icon icon="{{billingVisible ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'}}"></nb-icon>
			</a>
		}
	</div>
}

<div class="billing-container {{(showDecisionButtons || !billingVisible) ? '' : 'with-border'}}">
	<div [ngClass]="{'collapsed': !billingVisible}">
		<div [ngClass]="{'hide-section': !billingVisible}">

			<billing-preferences [order]="order">
				@if (!order.billingInformations.sameCompanyAndContactPersonAsProvided) {
					<div class="margin-top40">
						<company-address [order]="order" [countries]="countries" [isBillingAddress]="true"></company-address>
						<contact-person [order]="order" [isBillingContactPerson]="true"
										[emailBlocked]="false" [showEmailHint]="false" [showSalespeople]="false" [countries]="countries"></contact-person>
					</div>
				}
			</billing-preferences>

			@if (showDecisionButtons) {
				<div class="decision-buttons">
					<waiting-spinner [visible]="actionInProgress" [waitingText]="'common.spinner.loading' | translate"></waiting-spinner>
					<button id="cancel-button" nbButton status="warning" [disabled]="actionInProgress" outline (click)="cancel()">CANCEL</button>
					<button id="change-button" nbButton status="warning" [disabled]="!isChanged()" (click)="saveChanges()">CHANGE</button>
				</div>
			}
		</div>
	</div>
</div>
